import _ from 'lodash'

export default function (action, args) {
    console.log('cart-rule-action:modify_data', { action, args })

    console.log('action.options', action.options)

    let data = action.options.data || null
    if (data) {
        console.log('action.options.data', data)
        data = window.addiesaas.$fn.formatters.templify(JSON.parse(data), args)
        console.log('action.options.data.parsed', data)
    }

    _.merge(args, data)

    console.log('args', args)
}
